module.exports = __webpack_public_path__ + "img/canbadge_daishi_50_60mm_trimmark.7d1bed96.png";